import { render, staticRenderFns } from "./AppEditProject.vue?vue&type=template&id=839d902c&"
import script from "./AppEditProject.vue?vue&type=script&lang=js&"
export * from "./AppEditProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports